import React from 'react';
import styles from './Text.module.css';

const Text = ({ variant = '', as: Component = '', children, fontSize, isBold, className = ''}) => {
  
    let variantClass; 
    
    switch (variant) {
      case 'yellow-red':
        variantClass = styles.yellowRed;
        break;
      case 'yellow-green':
        variantClass = styles.yellowGreen;
        break;
      case 'red':
        variantClass = styles.red;
        break;
      case 'yellow':
        variantClass = styles.yellow;
        break;
      case 'grey':
        variantClass = styles.grey;
        break;
      default:
        break;
    }
    
    const boldClass = isBold ? styles.bold : ''

    const dynamicStyles = fontSize ? { fontSize: fontSize } : {};

    // Combina a classe base, a classe da variante e quaisquer classes personalizadas
    const combinedClasses = `${styles.text} ${variantClass} ${boldClass} ${className}`.trim();
  
    return (
      <Component className={combinedClasses} style={dynamicStyles}>
        {children}
      </Component>
    );
  };
  
  export default Text;